import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import HeaderPage from "../components/HeaderPage";
import DiagramaFinanzas from "../components/Finanzas/DiagramaFinanzas";
import PagosTable from "../components/Finanzas/PagosTable";
import { FaPlus, FaSearch, FaUserGraduate } from "react-icons/fa";
import { TbPigMoney } from "react-icons/tb";
import { useFinanzas } from "../context/FinanzasContext";
import Notification from "../components/Notification"; // Importa el componente Notification
import { useNavigate } from "react-router-dom";

const Finanzas = () => {
  const navigate = useNavigate();
  const { pagos = [] } = useFinanzas(); // Aseguramos que `pagos` siempre sea un array
  const [totalEstudiantes, setTotalEstudiantes] = useState(0);
  const [balance, setBalance] = useState(0);
  const [filteredPagos, setFilteredPagos] = useState([]);
  const currentYear = new Date().getFullYear().toString(); // Establece el año actual como el valor inicial
  const [filterYear, setFilterYear] = useState(currentYear);
  const [filterMonth, setFilterMonth] = useState("");
  const [searchQuery, setSearchQuery] = useState(""); // Estado para buscar por nombre

  // Estado para notificaciones
  const [notification, setNotification] = useState(null);

  const showNotification = ({ type, message }) => {
    setNotification({ type, message });
  };

  const handleCreateNew = () => {
    navigate("/finanzas/nuevo");
  };

  useEffect(() => {
    let pagosFiltrados = pagos;

    // Filtrar por año
    if (filterYear) {
      pagosFiltrados = pagosFiltrados.filter(
        (pago) => new Date(pago.fecha).getFullYear().toString() === filterYear
      );
    }

    // Filtrar por mes
    if (filterMonth) {
      pagosFiltrados = pagosFiltrados.filter(
        (pago) =>
          new Date(pago.fecha).getMonth() + 1 === parseInt(filterMonth, 10)
      );
    }

    setFilteredPagos(pagosFiltrados);

    // Actualizar métricas dinámicas
    const uniqueEstudiantes = new Set(
      pagosFiltrados.map((pago) => pago.students_id)
    );
    setTotalEstudiantes(uniqueEstudiantes.size);

    const totalBalance = pagosFiltrados.reduce(
      (sum, pago) => sum + pago.monto,
      0
    );
    setBalance(totalBalance);
  }, [pagos, filterYear, filterMonth]);

  // Obtener años únicos registrados en los pagos
  const availableYears = Array.from(
    new Set(pagos.map((pago) => new Date(pago.fecha).getFullYear().toString()))
  ).sort((a, b) => b - a); // Ordenar de mayor a menor

  return (
    <div className="flex flex-row min-h-screen overflow-hidden">
      <Sidebar />

      <main className="flex-1 p-4 md:p-6 overflow-x-hidden">
        <HeaderPage />

        {notification && (
          <Notification
            type={notification.type}
            message={notification.message}
            onClose={() => setNotification(null)}
          />
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 gap-y-4">
          <div className="bg-white p-4 rounded-lg flex items-center space-x-4">
            <div className="w-12 h-12 bg-main-bg-sidebar rounded-full flex items-center justify-center flex-shrink-0">
              <FaUserGraduate className="text-white text-2xl" />
            </div>
            <div>
              <h2 className="text-gray-600 font-semibold">Total Estudiantes</h2>
              <p className="text-xl md:text-2xl font-bold">{totalEstudiantes}</p>
            </div>
          </div>

          <div className="bg-white p-4 rounded-lg flex items-center space-x-4">
            <div className="w-12 h-12 bg-orange rounded-full flex items-center justify-center flex-shrink-0">
              <TbPigMoney className="text-white text-3xl" />
            </div>
            <div>
              <h2 className="font-semibold">Balance Escolar</h2>
              <p className="text-xl md:text-2xl font-bold">${balance.toLocaleString()}</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow mt-8 overflow-hidden">
          <div className="flex flex-wrap justify-between items-center mb-4">
            <h2 className="text-txtgray font-bold text-2xl">
              Ánalisis Balance
            </h2>
            <div className="flex flex-row flex-wrap gap-2 mt-2 md:mt-0 sm:flex-row sm:space-x-4 sm:space-y-0">
              <select
                value={filterYear}
                onChange={(e) => setFilterYear(e.target.value)}
                className="border rounded p-2 w-full sm:w-auto"
              >
                <option value="">Todos los años</option>
                {availableYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <select
                value={filterMonth}
                onChange={(e) => setFilterMonth(e.target.value)}
                className="border rounded p-2 w-full sm:w-auto"
              >
                <option value="">Todos los meses</option>
                {[
                  "Enero",
                  "Febrero",
                  "Marzo",
                  "Abril",
                  "Mayo",
                  "Junio",
                  "Julio",
                  "Agosto",
                  "Septiembre",
                  "Octubre",
                  "Noviembre",
                  "Diciembre",
                ].map((mes, index) => (
                  <option key={index} value={index + 1}>
                    {mes}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <DiagramaFinanzas
            pagos={filteredPagos}
            filterMonth={filterMonth}
            chartType="line"
          />
        </div>

        <div className="bg-white p-6 rounded-2xl shadow mt-8 overflow-hidden">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 mb-4">
            <h2 className="text-blue-900 font-bold text-lg md:text-xl">
              Historial Pagos Mensualidad Estudiantes
            </h2>
            <div className="flex items-center w-full md:w-1/2 bg-white border border-gray rounded-full px-4 py-2">
              <FaSearch className="mr-2" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Buscar por nombre..."
                className="w-full outline-none text-gray "
              />
            </div>
            <button
              onClick={handleCreateNew}
              className="flex items-center justify-center w-full md:w-auto px-5 py-3 text-sm bg-main-blue text-white rounded-full hover:bg-blue-800"
            >
              <FaPlus className="mr-2" /> Nuevo
            </button>
          </div>
          <PagosTable
            showNotification={showNotification}
            pagos={filteredPagos}
            searchQuery={searchQuery}
            filterYear={filterYear}
            filterMonth={filterMonth}
          />
        </div>
      </main>
    </div>
  );
};

export default Finanzas;
